import { CategoryDraftPayload } from './categoryAiDraft';

export interface BulkCategoryCreatePayload extends CategoryDraftPayload {
  includeInTasks: boolean;
  accessibilityType: number;
  isEnabled: boolean;
  parentCategoryId: number | null;
  courseIds: number[];
}

export const buildBulkCategoryCreatePayloads = (
  drafts: Array<CategoryDraftPayload & { id?: number }>,
): BulkCategoryCreatePayload[] => {
  return drafts.map((draft, index) => ({
    name: draft.name || `Category ${index + 1}`,
    description: draft.description || 'Add a short description',
    detailedDescription: draft.detailedDescription || '',
    tips: draft.tips || '',
    example: draft.example || '',
    wordDetailedDescription: draft.wordDetailedDescription || '',
    tags: draft.tags || '',
    sortOrder: draft.sortOrder ?? index + 1,
    approvalStatus: draft.approvalStatus || 'Pending Review',
    includeInTasks: false,
    accessibilityType: 1,
    isEnabled: false,
    parentCategoryId: null,
    courseIds: [],
  }));
};
